<div class="middle-box text-center animated fadeInDown">
    <h1></h1>
    <h3 class="font-bold">הדף המבוקש לא נמצא</h3>

    <div class="error-desc"><br>
        <br><a href="" class="btn btn-primary m-t">לוח הבקרה</a>
    </div>
</div>

                